"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreCommonPluginMethods = void 0;
// COMMONS plugins:
// enum, just for execute known methods
var CoreCommonPluginMethods;
(function (CoreCommonPluginMethods) {
    CoreCommonPluginMethods["Pre"] = "pre";
    CoreCommonPluginMethods["Post"] = "post";
    CoreCommonPluginMethods["Execute"] = "execute";
})(CoreCommonPluginMethods || (exports.CoreCommonPluginMethods = CoreCommonPluginMethods = {}));
//# sourceMappingURL=types.js.map